// src/modules/units/tyres/shared/tyre-access.js
//
// Who may do the administrator-only tyre operations: archive a retired tyre, see
// the archived list, and restore from it. The backend requires administrator
// access to the tyre's customer for all three.
//
// Like canManageBatches() (retread-batch-access.js), this is a UI affordance, not
// the security boundary — it only decides whether to SHOW the controls so a
// standard user isn't offered buttons that would 403. The server stays the
// authority, and every write still surfaces a clear "administrator access
// required" message if this check is ever wrong. Widen this one function if the
// policy changes.

import { getUserData } from '../../../auth/views/login/auth.api.js';

export function canArchiveTyres() {
  return getUserData()?.userRole === 'Administrator';
}
